import AppTheme from "@toothfairy/shared-ui/AppTheme";
import { useTranslation } from "react-i18next";
import { ScrollView, StyleSheet, Text, View } from "react-native";
import Markdown from "react-native-markdown-display";
import { isLargeScreen } from "../Screens/MainViewContainer";
import ToothFairyButton from "./ToothFairyComponents/ToothFairyButton";
import ToothFairyModal from "./ToothFairyComponents/ToothFairyModal";

const ReleaseNotesModal = ({
  visible,
  onClose,
  releaseNotes,
  currentVersion,
  setVisible,
}) => {
  const { t } = useTranslation();
  const { currentTheme } = AppTheme.useTheme();

  const markdownStyles = {
    body: {
      color: currentTheme?.theme?.font_color,
      fontSize: 14,
      lineHeight: 20,
    },
    heading1: {
      fontSize: 24,
      fontWeight: "bold",
      color: currentTheme?.theme?.primary,
      marginBottom: 16,
    },
    heading2: {
      fontSize: 18,
      fontWeight: "bold",
      color: currentTheme?.theme?.font_color,
      marginTop: 20,
      marginBottom: 12,
    },
    heading3: {
      fontSize: 16,
      fontWeight: "600",
      color: currentTheme?.theme?.font_color,
      marginTop: 16,
      marginBottom: 8,
    },
    paragraph: {
      marginBottom: 10,
    },
    listItem: {
      marginBottom: 5,
    },
    bullet_list: {
      marginLeft: 10,
    },
    strong: {
      fontWeight: "bold",
    },
    link: {
      color: currentTheme?.theme?.primary,
      textDecorationLine: "underline",
    },
  };

  return (
    <ToothFairyModal
      modalStyle={{
        height: 500,
        width: "90%",
        maxWidth: isLargeScreen() ? 750 : 350,
        marginHorizontal: "auto",
        marginTop: "auto",
        marginBottom: "auto",
        margin: "auto",
      }}
      isModalOpen={visible}
      setIsModalOpen={setVisible}
      modalTitle={`${t("misc.whatsNew")} (${currentVersion})`}
      closeModal={() => {
        setVisible(false);
        onClose?.();
      }}
    >
      <View
        style={[
          styles.container,
          { backgroundColor: currentTheme?.theme?.backgroundColor },
        ]}
      >
        <ScrollView style={styles.content} showsVerticalScrollIndicator={false}>
          {releaseNotes ? (
            <Markdown style={markdownStyles}>{releaseNotes}</Markdown>
          ) : (
            <View style={styles.loadingContainer}>
              <Text
                style={[
                  styles.loadingText,
                  { color: currentTheme?.theme?.primary },
                ]}
              >
                {t("misc.LoadingReleaseNotes")}
              </Text>
            </View>
          )}
        </ScrollView>

        <View style={styles.footer}>
          <ToothFairyButton
            title={t("misc.gotIt")}
            onPress={onClose}
            buttonStyle={styles.button}
            primary
          />
        </View>
      </View>
    </ToothFairyModal>
  );
};

const styles = StyleSheet.create({
  container: {
    borderRadius: 12,
    padding: 24,
  },
  header: {
    marginBottom: 20,
    alignItems: "center",
  },
  title: {
    fontSize: 28,
    fontWeight: "bold",
    marginBottom: 8,
  },
  version: {
    fontSize: 16,
  },
  content: {
    flex: 1,
    marginBottom: 20,
  },
  loadingContainer: {
    padding: 40,
    alignItems: "center",
    justifyContent: "center",
  },
  loadingText: {
    fontSize: 16,
  },
  footer: {
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: "rgba(0,0,0,0.1)",
    alignItems: "center",
  },
  button: {
    paddingVertical: 12,
  },
});

export default ReleaseNotesModal;
